<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">PWMLFF</div>
      </div>

      <img class="pwmat-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-introduce-container">

     <div class="pwmat-introduce-content">
       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">PWMLFF简介</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text">人工智能与传统计算机模拟的结合已经成为现代科学计算的一大趋势。在这个趋势中，机器学习力场的研究和应用成为了一个重要的方向。机器学习力场能够显著提升分子动力学模拟的精度和效率，这对于科学研究和工程应用都具有重要的意义。</p>
         <p class="pwmat-introduce-content-info-text">PWMLFF是一套由龙讯团队开发的开源软件包，它在GNU许可下开放源代码。PWMLFF的主要功能是快速生成机器学习力场，这些力场的精度可以与从头算分子动力学（AIMD）相媲美。这意味着，使用PWMLFF，研究人员可以在短时间内获得高精度的模拟结果，大大提高了研究效率。</p>
         <p class="pwmat-introduce-content-info-text">PWMLFF提供了一整套的解决方案，包括模型训练平台、Lammps的libtorch接口方案、主动学习平台、数据格式转换工具等。此外，它还提供了数据和模型仓库，以及详细的用户手册。这些功能和资源为用户提供了全方位的支持，使得用户可以更方便、更高效地使用PWMLFF进行科学计算和模拟。</p>
       </div>


       <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">1.PWMLFF用户手册</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='http://doc.lonxun.com/PWMLFF/'">http://doc.lonxun.com/PWMLFF</p>
         <p class="pwmat-introduce-content-info-text">PWMLFF用户手册提供了详细的PWMLFF工具集安装、使用以及案例说明文档</p>
       </div>
       
       <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">2.PWMLFF机器学习平台（tag:2024.3）</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='https://github.com/LonxunQuantum/PWMLFF'">https://github.com/LonxunQuantum/PWMLFF</p>
         <p class="pwmat-introduce-content-info-text">支持8种常见描述符、4种机器学习模型以及2种训练优化器</p>
       </div>
       
       <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">3.Lammps接口（tag:2024.3）</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='https://github.com/LonxunQuantum/Lammps_for_PWMLFF/tree/libtorch'">https://github.com/LonxunQuantum/Lammps_for_PWMLFF/tree/libtorch</p>
         <p class="pwmat-introduce-content-info-text">与PWMLFF模型无缝集成，支持CPU、GPU多卡分子动力学模拟</p>
       </div>
       
       <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">4.PWact主动学习平台(tag:0.1.0，支持 pip install pwact)</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='https://github.com/LonxunQuantum/PWact'">https://github.com/LonxunQuantum/PWact</p>
         <p class="pwmat-introduce-content-info-text">自动化主动学习采样，快速制备PWMLFF训练数据，支持PWMAT、VASP、CP2K、DFTB(PWMAT集成)等常用第一性原理软件</p>
       </div>
       
       <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">5.结构转换工具PWdata (tag:0.2.4，支持 pip install pwdata)</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='https://github.com/LonxunQuantum/pwdata'">https://github.com/LonxunQuantum/pwdata</p>
         <p class="pwmat-introduce-content-info-text">支持PWMAT、VASP、CP2K、Lammps之间的结构格式互转，支持各类结构到PWMLFF模型数据格式转换</p>
       </div>
       
      <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">6.训练数据集仓库</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='https://github.com/LonxunQuantum/PWMLFF_library'">https://github.com/LonxunQuantum/PWMLFF_library</p>
         <p class="pwmat-introduce-content-info-text">百度网盘下载：</p>
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='https://pan.baidu.com/s/1uO4mLgPha1mMD6DsZuCN_g?pwd=pwmt'">https://pan.baidu.com/s/1uO4mLgPha1mMD6DsZuCN_g?pwd=pwmt</p>
         <p class="pwmat-introduce-content-info-text">包含了常见体系的AIMD 数据集、一些已经过充分训练的PWMLFF 模型。便于用户快速复用数据集和模型，节省数据制备和模型训练成本。</p>
       </div>
       
      <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">7.PWMLFF测试案例</div>
         <div class="pwamt-introduce-line"></div>
       </div>

       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text" style="display: inline-block; margin-right: 30px; cursor: pointer; text-decoration: underline; color: blue"
            onclick="location.href='http://doc.lonxun.com/PWMLFF/examples/'">http://doc.lonxun.com/PWMLFF/examples/</p>
         <p class="pwmat-introduce-content-info-text">PWMLFF的测试结果以及使用PWMLFF的相关案例</p>
       </div>
       
       <div class="pwmat-introduce-content-title" style="padding-top: 20px">
         <div class="pwmat-introduce-content-title-text">PWMLFF技术支持群</div>
         <div class="pwamt-introduce-line"></div>
       </div>
          <div class="mstation-introduce-content-img">
            <img
              class="mstation-introduce-content-img-png"
              src="../../assets/produce/pwmlff/PWMLFF_support.png"
            />
          </div>

     </div>


     </div>
    </div>
</template>

<script>
  import {PWMAT_RESOURCE} from './../../helpers/consts'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        PWMAT_RESOURCE,
      }
    },
    methods:{
      toMSTATIONDownload(){
        this.$router.push({ name: 'MSTATIONDownload'})
      },
      toPotentialDownload(){
        this.$router.push({ name: 'PotentialDownload'})
      },
      toModuleDownload(){
        this.$router.push({ name: 'ModuleDownload'})
      },
      toManual(){
        window.open(this.PWMAT_RESOURCE+'Manual.pdf')
      },
      toProchureBook(){
        window.open(this.PWMAT_RESOURCE+'prochure.pdf')
      },
      toProchureNewFunctions(){
        window.open(this.PWMAT_RESOURCE+'PWmat_2019_new_functions.pdf')
      }

    }
  }
</script>

<style scoped>
  .pwmat-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-introduce-background{
    margin-top: 70px;
  }
  .pwmat-introduce-banner{
    overflow:hidden;
  }
  .pwmat-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-introduce-content-title{
    padding-top: 50px;
  }
  .pwmat-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-introduce-content-info{
    margin-top: 40px;
  }
  .pwmat-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwamt-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .pwmat-introduce-function{
    display: inline-block;
    padding-left: 80px;
    margin-bottom: 50px;
    width: 346px;
  }
  .pwmat-introduce-function-img{
    display: inline-block;
    vertical-align: top;
  }
  .pwmat-introduce-function-text{
    display: inline-block;
    vertical-align: top;
    margin-left: 23px;
  }
  .pwmat-introduce-function-name{
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 8px;
    margin-top: -6px;
  }
  .pwmat-introduce-function-desc{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:20px;
  }
  .pwmat-inroduce-application{
    background:rgba(73,145,201,0.1);
    padding: 24px 99px 27px 99px;
    margin-bottom: 50px;
  }
  .pwmat-inroduce-application-group-1{
    width:539px;
    display: inline-block;
  }
  .pwmat-inroduce-application-group-2{
    width:299px;
    display: inline-block;
  }
  .pwmat-inroduce-application-text{
    font-size:16px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:38px;
    margin-bottom: 0;
  }
  @media screen and (max-width:482px) {
    .pwmat-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-introduce-container{
      max-width: 1068px;
    }
  }

</style>
